<template>
    <div class="text-center text-lg">
        Page not found <br>
        {{ currentUrl }}
    </div>
</template>
<script>
export default {
    name: 'Notfound',
    data: function() {
        return {
            currentUrl: window.location.href,
        }
    },
}
</script>

